export function showNotification(message: string) {
  // Create notification element
  const notification = document.createElement("div");
  notification.textContent = message;
  notification.style.cssText = `
    position: fixed;
    top: 20px;
    right: -1000px;
    background-color: #333;
    color: white;
    padding: 15px;
    border-radius: 5px;
    opacity: 1;
    transition: all 0.5s ease-in-out;

  `;

  // Add notification to the page
  document.body.appendChild(notification);

  // Fade out after 5 seconds
  setTimeout(() => {
    notification.style.opacity = "0";
  }, 5000);

  // roll in animation
  setTimeout(() => {
    // notification.style.transform = "translateX(0px)";
    notification.style.right = "20px";
  }, 500);

  // Remove from DOM after fade out
  setTimeout(() => {
    document.body.removeChild(notification);
  }, 5500);
}
